export default "__VITE_ASSET__16741fa7__"